/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomTemplateRequest } from '../../models/custom-template-request';
import { ModifierTemplateRequest } from '../../models/modifier-template-request';
import { ProductTemplateRequest } from '../../models/product-template-request';

export interface SkumapTemplatesTemplateIdItemsItemIdAssociatePut$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
  itemId: string;
      body: (ProductTemplateRequest | ModifierTemplateRequest | CustomTemplateRequest)
}

export function skumapTemplatesTemplateIdItemsItemIdAssociatePut(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdItemsItemIdAssociatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdItemsItemIdAssociatePut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
    rb.path('itemId', params.itemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

skumapTemplatesTemplateIdItemsItemIdAssociatePut.PATH = '/skumap/templates/{templateId}/items/{itemId}/associate';
